import { render, staticRenderFns } from "./ForeignOverview.vue?vue&type=template&id=78be16ef&scoped=true"
import script from "./ForeignOverview.vue?vue&type=script&lang=js"
export * from "./ForeignOverview.vue?vue&type=script&lang=js"
import style0 from "./ForeignOverview.vue?vue&type=style&index=0&id=78be16ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78be16ef",
  null
  
)

export default component.exports